import { useMutation } from '@tanstack/react-query';
import { useFetcher } from '../../graphql';

/**
 * Hang up / cancel a call (≈ Slack calls.end). Either participant may end it;
 * the resulting ENDED/CANCELLED transition reaches the other party via their
 * useCallUpdates subscription.
 */
export const useEndCall = () => {
  const fetcherFn = useFetcher<
    { call: { endCall: { call: { id: string; state: string } } } },
    { input: { callId: string } }
  >(END_CALL);

  return useMutation({
    mutationFn: async (callId: string): Promise<{ id: string; state: string }> => {
      const data = await fetcherFn({ input: { callId } });
      return data.call.endCall.call;
    },
  });
};

const END_CALL = `
  mutation END_CALL($input: EndCallInput!) {
    call {
      endCall(input: $input) {
        call {
          id
          state
        }
      }
    }
  }
`;
